import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { IVXABI } from "./abi/IVXABI";

export class VXContractReveserveResult{
    public value:string;
    public cooldownUntil:string;
}

export class VXContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, IVXABI.GetABI(), provider);
    }

    async stakeAsync(valueEth:string, withPost:boolean=false): Promise<any>
    {
        const valueWEI = this._toWei(valueEth);
        const result = await this._pay(valueWEI, "stake", withPost);
        return result;
    }

    async unstakeAsync(valueVX:string, withPost:boolean=true): Promise<any>
    {
        const valueVXWEI = this._toWei(valueVX);
        const result = await this._send("unstake", valueVXWEI, withPost);
        return result;
    }

    async withdraw(valueEth:string, forAddress:string): Promise<any>
    {
        const valueWEI = this._toWei(valueEth);
        const result = await this._send("withdraw", valueWEI, forAddress);
        return result;
    }

    async getWithdrawalAsync(forAddress:string): Promise<string>
    {
        const withdrawal = await this._call("getWithdrawal", forAddress);
        return this._toDecimal(withdrawal);
    }

    async getTotalWithdrawalValueAsync(): Promise<string>
    {
        const withdrawal = await this._call("totalWithdrawalValue");
        return this._toDecimal(withdrawal);
    }

    async getReserveOfAsync(forAddress:string): Promise<VXContractReveserveResult>
    {
        const result = await this._call("reserveOf", forAddress);
        if (!result) return;
        result.value = this._toDecimal(result.value);
        return result;
    }
    async withdrawReserveAsync(): Promise<any>
    {
        const result = await this._send("withdrawReserve");
        return result;
    }
}